import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const buttonVariants = cva(
  [
    "inline-flex items-center justify-center whitespace-nowrap rounded-lg",
    "text-sm font-medium transition-colors",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple focus-visible:ring-offset-2",
    "disabled:pointer-events-none disabled:opacity-50"
  ].join(" "),
  {
    variants: {
      variant: {
        default: [
          "bg-purple text-white",
          "hover:bg-purple-dark",
          "active:bg-purple-dark/90"
        ].join(" "),
        secondary: [
          "border border-purple text-purple",
          "bg-transparent",
          "hover:bg-purple/10"
        ].join(" "),
        ghost: [
          "text-text-secondary",
          "hover:bg-purple/10 hover:text-purple"
        ].join(" "),
        destructive: [
          "bg-negative text-white",
          "hover:bg-negative/90"
        ].join(" "),
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4",
        lg: "h-12 px-6 text-base"
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants } 